import { UIHeading4, Body2, ArticleParagraph3 } from '@cian/ui-kit/typography';

import type { IMainProp, IRate } from 'shared/utils/buildingMainBlock';

import style from './style.css';

export interface IBuildingMainPropsProps {
  props: IMainProp[];
  rates: IRate[];
}

export const BuildingMainProps = ({ props, rates }: IBuildingMainPropsProps) => (
  <div className={style['container']} data-name="BuildingMainProps">
    {props.length > 0 && (
      <dl className={style['props']}>
        {props.map(({ name, value }) => (
          <div key={name} className={style['prop']}>
            <dt>
              <Body2 fontWeight="bold">{name}</Body2>
            </dt>
            <dd className={style['value']}>
              <Body2 fontWeight="bold">{value}</Body2>
            </dd>
          </div>
        ))}
      </dl>
    )}
    {rates.length > 0 && (
      <dl className={style['rates']}>
        {rates.map(({ name, value }) => (
          <div key={name} className={style['rate']}>
            <dt>
              <ArticleParagraph3 fontWeight="bold">{name}</ArticleParagraph3>
            </dt>
            <dd className={style['value']}>
              <UIHeading4 as="span">{value}</UIHeading4>
            </dd>
          </div>
        ))}
      </dl>
    )}
  </div>
);
